import LearnSourceService from '@/services/LearnSourceService'

const createLearnSourcesModule = () => ({
  namespaced: true,
  state: {
    page: 1,
    pages: 1,
    pageSize: 15,
    total: 0,
    learnSources: []
  },
  actions: {
    getLearnSources: ({ commit, state }) => {
      LearnSourceService.getLearnSources(state.pageSize, state.page)
        .then((data) => {
          commit('SET_LEARN_SOURCES', {
            learnSources: data.learnSources
          })
          commit('SET_PAGES', { pages: data.pages })
          commit('SET_TOTAL', { total: data.total })
        })
        .catch((err) => {
          console.info(err)
        })
    },
    setPage: ({ dispatch, commit, state }, page) => {
      commit('SET_PAGE', { page })
      dispatch('getLearnSources')
    }
  },
  getters: {
    prevDisabled: (state) => state.page === 1,
    nextDisabled(state) {
      return state.pageSize * state.page >= state.total
    }
  },
  mutations: {
    SET_LEARN_SOURCES: (state, { learnSources }) => {
      state.learnSources = learnSources
    },
    SET_PAGES: (state, { pages }) => {
      state.pages = pages
    },
    SET_PAGE: (state, { page }) => {
      state.page = page
    },
    SET_TOTAL: (state, { total }) => {
      state.total = total
    }
  }
})

export default createLearnSourcesModule
